<div *ngIf="meeting && meeting.status !== InterviewStatus.CANCELLED && meeting.status !== InterviewStatus.DECLINED">
  <div class="flex justify-center mt-[44px]" *ngIf="!declineInterview">
    <button class="flex items-center gap-1 text-info-200 text-5 leading-24" (click)="declineInterview = true">
      <span class="text-4">Unable to attend this interview?</span>
      <span>
          <img src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/icons/expand_more-Info-200.svg">
      </span>
    </button>
  </div>

  <div class="mt-[44px] mx-auto max-w-[448px]" *ngIf="declineInterview">
    <div class="text-neutral-500 text-4 leading-24 mb-7">We understand circumstances may change. Please let us know why you are unable to attend this interview.</div>
    <div class="text-neutral-700 text-2 leading-16 mb-1">Notes (Optional)</div>
    <textarea
      (input)="declineNotesChange($event)"
      maxlength="500"
      class="w-full min-h-[126px] resize-y text-4"
    ></textarea>
    <div class="text-right text-neutral-700 text-2 leading-18">{{declineNotes.length}}/500</div>
    <div class="flex flex-col">
      <div class="tablet:flex justify-end mt-7">
        <button
          class="mobile:w-full tablet:w-auto bg-error-500 hover:bg-error-400 active:bg-error-600 rounded px-6 py-4 text-light"
          [disabled]="disableDeclineButton"
          (click)="clickDeclineInterview(meeting)">
          Decline Interview
        </button>
      </div>
      <div class="mx-auto mt-7">
        <button class="flex items-center gap-1 text-info-200 text-5 leading-24"
          (click)="declineInterview = false">
          <span class="text-4">Close</span>
          <span>
            <img src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/icons/expand_less-Info-200.svg">
            </span>
        </button>
      </div>
    </div>
  </div>
</div>
